.bar {
	flex: none;
	z-index: 100;
	display: flex;
	justify-content: center;
	gap: var(--space-2);
	height: calc(var(--tab-bar-h) + env(safe-area-inset-bottom));
	padding-bottom: env(safe-area-inset-bottom);
	background: var(--surface-page);
	border-top: 1px solid var(--border);
}

/* Set by fitToKeyboard, so the bar doesn't ride up on top of the keyboard. */
:global(html[data-keyboard]) .bar {
	display: none;
}

.tab {
	flex: 1 1 0;
	max-width: 96px;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	gap: 2px;
	padding-top: var(--space-1);
	color: var(--ink-muted);
	text-decoration: none;
	-webkit-tap-highlight-color: transparent;
}

.tab:hover {
	text-decoration: none;
}

.tab[aria-current='page'] {
	color: var(--accent-sage);
}

.icon {
	display: block;
}

.label {
	font-size: 0.625rem;
	line-height: 1;
	font-weight: 500;
	letter-spacing: 0.01em;
}
